
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","xmlns":"http://www.w3.org/2000/svg","overflow":"visible","preserveAspectRatio":"none","viewBox":"0 0 27 27","height":"25","width":"25"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)"}},[_c('path',{attrs:{"d":"M21.5 17.234a3.5 3.5 0 110 7 3.5 3.5 0 010-7zM23.899 1.36c1.291 1.178 1.34 2.67.167 4.254l-.135.177-7.5 7.5-.087.074-7.452 5.463-1.925 1.926a1.5 1.5 0 01-.035 1.855l-.1.11-.729.73a1.5 1.5 0 01-2.007.102l-.114-.103-2.783-2.783a1.5 1.5 0 01-.103-2.008l.103-.113.728-.729a1.5 1.5 0 012.005-.104l1.66-1.525.274-.273 5.397-6.868.076-.083 8.063-7.553C21.007.205 22.586.163 23.9 1.36zM21.5 18.734a2 2 0 100 4 2 2 0 000-4zm-18.529.158l-.712.712 2.784 2.784.711-.713-2.783-2.783zm2.863-.89L5 18.768l.915.915.8-.8-.88-.881zm1.787-1.895l-.679.865-.009.008.843.843.094-.093.087-.074.7-.514-1.036-1.035zM20.53 2.439l-.165.117-7.962 7.463-3.849 4.9 1.325 1.325 5.528-4.053 7.405-7.396c.71-.897.783-1.529.278-2.12l-.095-.103-.107-.104c-.701-.64-1.437-.656-2.358-.03z","vector-effect":"non-scaling-stroke","fill":"#bcb9ba","fill-rule":"nonzero"}})])])
          )
        }
      }
    